import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { FormGroup, FormGroupName, FormsModule } from '@angular/forms';
import { PlanFormComponent } from './plan-form/plan-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { PlanListComponent } from './plan-list/plan-list.component';
import { AdminRequestsComponent } from './admin-requests/admin-requests.component';
import { AdminRequestDetailComponent } from './admin-request-detail/admin-request-detail.component';
import { CreateProjetButtonComponent } from './create-projet-button/create-projet-button.component';
import { CreateProjetModalComponent } from './create-projet-modal/create-projet-modal.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
       FormsModule,
       MatCardModule,
       MatButtonModule,
       MatIconModule,
       MatInputModule,
       MatFormFieldModule,
       MatProgressSpinnerModule,
       MatTooltipModule,
       MatMenuModule,
       ReactiveFormsModule,
        MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule

  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    AdminDashboardComponent,
    PlanFormComponent,
    PlanListComponent,
    AdminRequestsComponent,
    AdminRequestDetailComponent,
    CreateProjetButtonComponent,
    CreateProjetModalComponent,
    
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent
  ]
})
export class ComponentsModule { }
